<script setup>
import { ref, watch, nextTick, onMounted} from "vue"
import axiosIns from "@/plugins/axios.js"
import Banner from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/banner.vue'
import JobCard from "@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/job_card.vue"
import Footer from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/footer.vue'
import { useStore } from "vuex"
import { useRoute } from 'vue-router'

const id_applicant = JSON.parse(localStorage.getItem('userData'))?.id_usuario

const route = useRoute()
const store = useStore();
const filteredData = ref(null)
const allData = ref(null)
const favorites = ref([])
const applications = ref([])
const keywordSearch = ref(route.query.keyword || null)
const selectedPosition = ref(route.query.position || [])
const selectedPlace = ref(route.query.place || [])

const getData = () => {

    const config = {
        method: "get",
        url: "/talentoagv/readJobOffersApplicant/",
    };

    axiosIns(config)
    .then(function (response) {
        if (response.data["is_error"] === false) {
            const resultado = response.data["result"];
            allData.value = resultado;
            if(keywordSearch || selectedPosition || selectedPlace){
                localFilter();
            }else{
                filteredData.value = resultado;
            }

            if (id_applicant) {
                getFavorites()
            }

        }
    })
    .catch(function (error) {
        console.log(error);
    });
}

const getFavorites = () => {

    const params = {
        applicant_id : id_applicant,
    }

    const config = {
        method: "post",
        url: "/talentoagv/getFavoriteOffers/",
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    };

    axiosIns(config)
    .then(function (response) {
        favorites.value = response.data["result"];
        for (let a of filteredData.value) {
            a.isfavorite = favorites.value.some(b => a.id === b.key_oferta_lab)
        }

        if (id_applicant) {
            getApplications()
        }

    })
    .catch(function (error) {
        console.log(error);
    });

}

const getApplications = () =>{
  
    const params = {
        applicant_id : id_applicant,
    }

    const config = {
        method: "post",
        url: "/talentoagv/get-applied-offers/",
        data: params
    };

    axiosIns(config)
    .then(function (response) {
        applications.value = response.data["result"];
        for (let a of filteredData.value) {
            a.isapplicated = applications.value.some(b => a.id === b.key_oferta_lab_id)
        }
    })
    .catch(function (error) {
        console.log(error);
    });

}

const localFilter = () => {
    const query = keywordSearch.value ? keywordSearch.value.toLowerCase() : "";
    filteredData.value = allData.value.filter((offer) => {
        const matchesWorkPos =
            selectedPosition.value.length === 0 ||
            selectedPosition.value.some((pos) =>
            offer.work_pos.toLowerCase().includes(pos.toLowerCase())
        );

        const matchesPlace =
            selectedPlace.value.length === 0 ||
            selectedPlace.value.some((place) =>
            offer.place.toLowerCase().includes(place.toLowerCase())
        );

        const matchesQuery =
            !query ||
            offer.work_pos.toLowerCase().includes(query) ||
            offer.place.toLowerCase().includes(query);

        return matchesWorkPos && matchesPlace && matchesQuery;
    });
}

const clearFilters = () => {
    filteredData.value = allData.value
}

onMounted(async () => {
    getData()   
})
watch(
    () => route.query,
    (newQuery) => {
    keywordSearch.value = newQuery.keyword || null
    selectedPosition.value = Array.isArray(newQuery.position) 
        ? newQuery.position 
        : (newQuery.position ? [newQuery.position] : [])
    selectedPlace.value = Array.isArray(newQuery.place) 
        ? newQuery.place 
        : (newQuery.place ? [newQuery.place] : [])

    if (allData.value) {
        localFilter()
    }
    },
    { immediate: true }
)

</script>
<template>
    <Banner/>
    <div class="container my-5">
        <div class="row mb-4">
            <div class="col-12 col-md-8">
                <span class="text-muted me-2">Todos los puestos de trabajo:</span>
                <strong class="me-3">{{ filteredData ? filteredData.length : 0 }} Resultados</strong>
                <button class="btn-link-reset" type="button" @click="clearFilters">
                Limpiar filtros
                </button>
            </div>
            <div v-if="id_applicant" class="col-12 col-md-4" style="display: flex; justify-content: end; flex-wrap: wrap;">
                <router-link class="text-muted me-4" to="/favoritos">
                    <i class="fa-solid fa-heart"></i>
                    Mis Favoritos
                </router-link>

                <router-link class="text-muted" to="/postulaciones">
                    <i class="fa-solid fa-flag"></i>
                    Mis Postulaciones
                </router-link>
            </div>
        </div>
        <div class="row g-4">
            <template v-for="(job, index) in filteredData" :key="job.id">
                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <!-- Cambiar img por job.s3_url -->
                    <div class="content-job-card">
                        <JobCard
                        :id="job.id"
                        :title="job.work_pos"
                        :vacancies="job.n_vacancy"
                        :place="job.place"
                        :image="job.s3_url"
                        :isfavorite="job.isfavorite"
                        :isapplicated="job.isapplicated"
                        />
                    </div>
                </div>
            </template>
        </div>
    </div>
    <Footer/>
</template>
<style scoped>

.content-job-card {
    margin-top: 100px;
    display: flex;
    justify-content: center;
}

.topbar-link {
    background: transparent;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as);
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    cursor: pointer;
}

.btn-link-reset {
    background: none;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as-light);
    font-weight: 500;
    cursor: pointer;
}

.btn-link-reset:hover {
    text-decoration: underline;
}

</style>
